import React, { useEffect, useRef, useState } from 'react';
import '../CustomerInvoiceView/css/SkeletonLoader.css';
import PurchaseOrderHeader from './PurchaseOrderHeader';
import PurchaseOrderProductTable from './PurchaseOderProductTable';
import PurchaseOrderBottomSection from './PurchaseOrderBottomSection';
import PurchaseOrderFooterSection from './PurchaseOrderFooterSection';
import PurchaseOrderErrorPage from './purchaseOrderErrorPage';
import { PurchaseOrderService } from 'src/services/PurchaseOrderService';

function PublicPurchaseOrderView() {
  const [isLoading, setIsLoading] = useState(true);
  const [errorOccurred, setErrorOccurred] = useState(false);
  const [error, setError] = useState<string | undefined>();
  const [purchaseOrderData, setPurchaseOrderData] = useState<any>(null);
  const purchaseOrderNumberRef = useRef(null);

  const getPurchaseOrderData = async (purchaseOrderNumber: string) => {
    try {
      const response = await PurchaseOrderService.getPurchaseOrderDisplayData(
        purchaseOrderNumber
      );

      if (response.success) {
        setPurchaseOrderData(response.data);
        setIsLoading(false);
      } else {
        setError(response.error);
        setErrorOccurred(true);
      }
    } catch (error) {
      setIsLoading(false);
      setError('Connection Error!');
      setErrorOccurred(true);
    }
  };

  useEffect(() => {
    const url = window.location.href;
    const purchaseOrderNumber = url.split('/').pop();
    purchaseOrderNumberRef.current = purchaseOrderNumber;

    getPurchaseOrderData(purchaseOrderNumberRef.current);
  }, []);

  return (
    <>
      {!errorOccurred ? (
        isLoading ? 
        <div className="purchaseOrder-container">
          <div className="skeleton-wrapper">
            <div className="skeleton-header"></div>
            <div className="skeleton-line"></div>
            <div className="skeleton-line"></div>
            <div className="skeleton-header"></div>
            <div className="skeleton-line"></div>
            <div className="skeleton-line"></div>
            <div className="skeleton-line"></div>
            <div className="skeleton-line"></div>
            <div className="skeleton-header"></div>
            <div className="skeleton-line"></div>
            <div className="skeleton-line"></div>
            <div className="skeleton-line"></div>
          </div>
        </div> :
        <div className="purchaseOrder-container">
          <PurchaseOrderHeader purchaseOrderData={purchaseOrderData} />
          <PurchaseOrderProductTable purchaseOrderData={purchaseOrderData} />
          <PurchaseOrderBottomSection purchaseOrderData={purchaseOrderData} />
          <PurchaseOrderFooterSection purchaseOrderData={purchaseOrderData} />
        </div>
      ) : (
        <div>
          <PurchaseOrderErrorPage error={error} />
        </div>
      )}
      <div className="bottom-space"></div>
    </>
  );
}

export default PublicPurchaseOrderView;
